import styled from "styled-components";
import { GizmoContainerResize } from "../../utils";

const Custom = styled(GizmoContainerResize)``;

export { Custom };
